import { Controller } from "@hotwired/stimulus";
import "./component.scss"

export default class extends Controller {
  static targets = ["list", "listItem", "searchInput"];

  connect() {}

  search(event) {
    let query = event.target.value.toLowerCase().trim();
    if (query.length === 0) {
      this.listTarget.hidden = true;
      return;
    }

    this.openList();
    this.filterListElements(query);
  }

  filterListElements(query) {
    this.listTarget.querySelectorAll("[data-creator-search-target='listItem']").forEach((item) => {
      item.style.display = this.itemInQuery(item, query) ? "flex" : "none";
    })
  }

  openList() {
    this.listTarget.hidden = false;
  }

  itemInQuery(item, query) {
    let name = item.querySelector("[data-creator-search-target='name']").textContent.toLowerCase();
    return name.includes(query);
  }
}
